import { MsaFlax } from "@maven-rest/orchestra/Msa.flax";
import React from "react";
import { useRequest } from "@coralblack/flax";
import { useInterval } from "@maven-surface/hooks";

export function Waken() {
  const { request } = useRequest({ ...MsaFlax.waken({}) });

  useInterval(() => {
    request();
  }, 60 * 1000);

  return (
    <>
      <div style={{ visibility: "hidden", width: 0, height: 0 }}>Waken: {new Date().toString()}</div>
    </>
  );
}
